export const REGIONAL_ADMINISTRATIONS_DIRECTOR = 'director_json';
export const REGIONAL_ADMINISTRATIONS_REGION_ID = 'region_id';
export const REGIONAL_ADMINISTRATIONS_START_TIME = 'start_time';
export const REGIONAL_ADMINISTRATIONS_END_TIME = 'end_time';
export const REGIONAL_ADMINISTRATIONS_ADDRESS = 'address_json';
export const REGIONAL_ADMINISTRATIONS_EMAIL = 'email';
export const REGIONAL_ADMINISTRATIONS_PHONE_NUMBER = 'phone_number';
